import { uniqueIdentifierForNode } from '@ctw/shared/content/document-viewer/_internal/renderers/helpers';
import { uniqueIdentifierHash } from '@ctw/shared/utils/hash';
import {} from 'lodash-es';
import { useMemo } from 'react';
import type { CdaSection } from '../../parsers/types';
import { ReactNodeRenderer } from './react-node-renderer';

interface HtmlRendererProps {
  section: CdaSection;
  html: string;
}

export const ReactHtmlRenderer = ({ section, html }: HtmlRendererProps) => {
  // Note: DOM Parser can't handle multiple root nodes
  const nodes = useMemo(
    () =>
      Array.from(
        new DOMParser().parseFromString(`<div>${html}</div>`, 'application/xml').children[0]
          .childNodes,
      ),
    [html],
  );

  return (
    <>
      {nodes.map((node, index) => {
        const nodeIdentifier = uniqueIdentifierForNode({
          section,
          node,
          context: `node-html-child-${uniqueIdentifierHash(html)}`,
          index,
        });

        return (
          <ReactNodeRenderer
            id={nodeIdentifier}
            key={nodeIdentifier}
            section={section}
            node={node}
          />
        );
      })}
    </>
  );
};
